export default __webpack_public_path__ + "081a2311b9dc01e9d49fed466478d7bc.png";